import { useState } from 'react';

export type VZUpdateIndicator = number;

export default function useUpdateIndicator(): [number, () => void] {
    const [indicator, setIndicator] = useState(0);

    return [indicator, () => setIndicator(indicator + 1)];
}
